import { render, staticRenderFns } from "./WhyIDontSeeSurnames.vue?vue&type=template&id=ce6a7748"
import script from "./WhyIDontSeeSurnames.vue?vue&type=script&lang=js"
export * from "./WhyIDontSeeSurnames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports